var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3999 4.5C7.3999 4.5 3.1299 7.61 1.3999 12C3.1299 16.39 7.3999 19.5 12.3999 19.5C17.3999 19.5 21.6699 16.39 23.3999 12C21.6699 7.61 17.3999 4.5 12.3999 4.5ZM12.3999 17C9.6399 17 7.3999 14.76 7.3999 12C7.3999 9.24 9.6399 7 12.3999 7C15.1599 7 17.3999 9.24 17.3999 12C17.3999 14.76 15.1599 17 12.3999 17ZM12.3999 9C10.7399 9 9.3999 10.34 9.3999 12C9.3999 13.66 10.7399 15 12.3999 15C14.0599 15 15.3999 13.66 15.3999 12C15.3999 10.34 14.0599 9 12.3999 9Z",
    fill: "#0288D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlue);
export default __webpack_public_path__ + "static/media/eyeBlue.d78f1a7761206790dafb95a9b0573676.svg";
export { ForwardRef as ReactComponent };